import config from "@shared/config/client";
import { NftCommentDto } from "./types";
import queryString from "query-string";
import { ICallableRequestBuilder } from "@/api/requestBuilder/types";

const getNftComments =
  (request: ICallableRequestBuilder<NftCommentDto[]>) =>
  async (nftId: string) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/comments/nft/${nftId}`,
    });

    return await request.call(url, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const requests = {
  getNftComments,
};

export default requests;
